<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="form-group">
            <label for="equipment">Equipment</label>
            <wj-combo-box
                id="equipment"
                name="equipment"
                [(ngModel)]="target.equipment"
                [itemsSource]="equipmentOptions"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                required
            ></wj-combo-box>
        </div>
        <div class="form-group">
            <label for="batterySizeGroup">Battery size/group</label>
            <input id="batterySizeGroup" type="text" class="form-control" [(ngModel)]="target.batterySizeGroup" name="batterySizeGroup" required />
        </div>
        <div class="form-group">
            <label for="notes">Notes</label>
            <textarea id="notes" class="form-control" rows="2" [(ngModel)]="target.notes" name="notes"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
